/**
 * Base/default configuration shared across all tenants
 * Tenant-specific configs should spread this and override as needed
 */

import type { FeaturesConfig, SupportConfig } from '../types'

/** Default feature flags - conservative defaults (most features off) */
export const defaultFeatures: FeaturesConfig = {
  minorSelection: false,
  twoToFourYear: false,
  savedPlans: false,
}

/** Default support configuration - should be overridden per tenant */
export const defaultSupport: SupportConfig = {
  contactEmail: 'support@damoursystems.com',
  helpUrl: undefined,
}

/** Common accent colors used across tenants */
export const commonColors = {
  success: '#5AD9BB',
  error: '#FF5A73',
  shade: '#f6f6f6',
  backgroundShade: '#f6f6f6',
  neutral1: '#F2F7EB',
  neutral2: '#333333',
  neutral3: '#e7e7e7',
}
